<script setup lang="ts">
import { errorToast, successToast } from "@/utils/custom-toast";
import { defineEmits, defineProps } from "vue";
import { useTranslate } from "@/composables/useTranslate";
import client from "@/utils/axios";

type Props = {
  isDeleteDialogOpen: boolean;
  bonusDate: any;
};

const props = defineProps<Props>();

type Emits = {
  (event: "onClose"): void;
  (event: "decreaseDialogStage"): void;
  (event: "increaseDialogStage"): void;
};

const emits = defineEmits<Emits>();
const { t } = useTranslate();

const handleClose = () => {
  emits("onClose");
};

const handleDelete = async () => {
  try {
    await client.delete("/installers/monthly-bonus/report", {
      data: {
        month: props.bonusDate.monthNumber,
        year: props.bonusDate.year,
      },
    });
    successToast(
      `${t("installers.delete_success").value} ${props.bonusDate.month}/${
        props.bonusDate.year
      }`
    );
    emits("onClose");
  } catch (error: any) {
    errorToast(error);
    console.log(error);
  }
};
</script>
<template>
  <Transition name="nested">
    <div
      v-if="isDeleteDialogOpen"
      class="w-full h-screen fixed top-0 left-0 bg-black/75 z-[1000]"
    >
      <div
        class="w-full max-w-[628px] min-h-[246px] px-[20px] fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 rounded-[7px] bg-white z-[1000]"
      >
        <div class="flex items-center justify-between py-[16px] mb-[16px]">
          <div class="flex items-center">
            <p class="text-[20px] font-semibold text-[#393840]">
              {{ t("global.delete") }} {{ bonusDate.month?.trim() }}/{{
                bonusDate.year
              }}
              {{ t("installers.monthly_bonus_report") }}
            </p>
          </div>
          <img
            class="h-[12px] w-[12px] cursor-pointer"
            src="@/assets/close-icon-2.svg"
            alt=""
            @click="handleClose()"
          />
        </div>

        <div
          class="max-h-[102px] text-[20px] pb-[6px] border-b border-[#E3E1EA] rounded-tl-[7px]"
        >
          <p>
            {{ t("installers.are_you_sure_delete") }}
            {{ bonusDate.month?.trim() }}/{{ bonusDate.year }}
            {{ t("installers.monthly_bonus_report") }}?
          </p>
          <p>{{ t("installers.cannot_be_undone") }}.</p>
        </div>

        <div class="py-[16px] flex items-center justify-end gap-[16px]">
          <button
            @click="handleClose()"
            class="min-w-[79px] flex items-center justify-center p-[12px] text-[16px] text-white font-semibold border-2 border-[#393840] rounded-[7px]"
          >
            <span class="text-[#393840]">{{ t("global.cancel") }}</span>
          </button>
          <button
            @click="handleDelete()"
            class="min-w-[154px] flex items-center text-nowrap p-[12px] gap-[8px] text-[16px] text-[#393840] font-semibold bg-[#F4B6B2] rounded-[7px]"
          >
            <img
              class="w-[18px] h-[18px]"
              src="@/assets/trash-icon-black.svg"
              alt=""
            />
            <span class="min-w-[104px]">{{
              t("installers.delete_report")
            }}</span>
          </button>
        </div>
      </div>
    </div>
  </Transition>
</template>
